import ApiRequest from "../util/ApiRequest";
import GlobalData from "../util/GlobalData";

export default class PresenceForm {
    create = async (body) => {
        return await ApiRequest.set(`/v1/presence_forms`, "POST", body);
    }
}
